export default "__VITE_ASSET__31e67d18__"